import { render, staticRenderFns } from "./goodsCode.vue?vue&type=template&id=28d4d38a&scoped=true&"
import script from "./goodsCode.vue?vue&type=script&lang=js&"
export * from "./goodsCode.vue?vue&type=script&lang=js&"
import style0 from "./goodsCode.vue?vue&type=style&index=0&id=28d4d38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4d38a",
  null
  
)

export default component.exports